<template>
  <nav class="app-nav">
    <router-link to="/" class="nav-link" active-class="active">
      <i class="fas fa-chart-line"></i>
      数据概览
    </router-link>
    <router-link to="/map" class="nav-link" active-class="active">
      <i class="fas fa-map"></i>
      区域地图
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'AppNav',
};
</script>

<style scoped>
.app-nav {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  padding: 4px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  width: fit-content;
}

.nav-link {
  padding: 10px 18px;
  text-decoration: none;
  color: #666;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.nav-link:hover {
  color: #1677ff;
  background: #f5f8ff;
}

.nav-link.active {
  color: #1677ff;
  font-weight: 600;
  background: #e6f4ff;
}

.nav-link i {
  margin-right: 6px;
}
</style>
